import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson40: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson39"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Iron</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson41"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>{`What Is Iron & Why Is It Important?`}</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Iron is a nutrient that plays a vital role in oxygen
                  transport. It binds to hemoglobin, a special protein, and
                  helps it carry red blood cells from your lungs to other
                  tissues in your body.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Iron is naturally available in the foods you eat, and there
                  are two main types — heme and nonheme iron.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The term “heme” is derived from a Greek word that loosely
                  translates to “blood.” This type of iron comes from animal
                  protein, such as poultry, fish, and beef.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  On the other hand, nonheme iron comes from plant sources,
                  including legumes, leafy greens, and nuts.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Heme iron is easiest for your body to absorb and is 14–18%
                  bioavailable in mixed diets. Nonheme iron, the iron source in
                  vegetarian diets, has a bioavailability of 5–12%. Too much or
                  too little iron in your diet can lead to health issues like
                  liver problems, iron-deficiency anemia, and heart damage.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Naturally, you may wonder just how much iron is an ideal
                  amount. Here’s where it gets a little tricky.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  While generalized recommendations offer some guidance, your
                  specific iron needs are influenced by many factors, including
                  age, sex, and diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Iron is an essential nutrient. Two types of iron are found in
                  the human diet — heme iron comes from animal protein, while
                  nonheme iron comes from plants. Your body can absorb heme iron
                  more readily.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How To Get Enough Iron</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Heme iron is the richest and most efficiently absorbed type.
                It’s most concentrated in shellfish, organ meats, poultry, and
                eggs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Rich vegetarian sources of iron include chickpeas, quinoa,
                seeds, beans, fortified cereals, and leafy greens.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Plus, dark chocolate contains a surprising amount of iron, at
                19% of the Daily Value (DV) per 1-ounce (28-gram) serving.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Keep in mind that RDAs are specific to sex and age groups, while
                product labels generally refer to the DV. The DV is a fixed
                number, independent of sex or age. The established DV for iron
                across biological sexes and ages is 18 mg.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                What’s more, what you eat alongside iron-rich foods matters.
                Pairing your high-iron foods with foods rich in vitamin C like
                fruits and vegetables increases iron absorption.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For instance, drinking orange juice with a plate of eggs
                increases your body’s absorption of the iron in eggs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Conversely, accompanying your high-iron foods with calcium-rich
                foods, such as drinking milk with a plate of eggs, inhibits iron
                absorption. Therefore, it’s best to consume calcium-rich foods
                at a separate time.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Iron Rich Foods</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <b>
                <span>&nbsp;</span>
              </b>
            </p>
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Shellfish</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Shellfish is tasty and nutritious. All shellfish is high in
                    iron, but clams, oysters, and mussels are particularly good
                    sources.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    For instance, a 3.5-ounce (100-gram) serving of clams may
                    contain up to 3 mg of iron, which is 17% of the DV.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    However, the iron content of clams is highly variable, and
                    some types may contain much lower amounts.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The iron in shellfish is heme iron, which your body absorbs
                    more easily than the non-heme iron found in plants.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 3.5-ounce serving of clams also provides 26 grams of
                    protein, 24% of the DV for vitamin C, and a whopping 4,125%
                    of the DV for vitamin B12.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    In fact, shellfish are a good source of omega-3 fatty acids
                    which have been shown to increase the levels of
                    heart-healthy HDL cholesterol.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Although there are legitimate concerns about mercury and
                    toxins in certain types of fish and shellfish, the benefits
                    of consuming seafood far outweigh the risks.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    The EPA and FDA recommend eating 2 to 3 servings of seafood
                    a week from their “Best Choices” list, which includes such
                    shellfish as clams, oysters, and scallops.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    A 3.5-ounce (100-gram) serving of clams provides 17% of the
                    DV for iron. Shellfish is also rich in many other nutrients
                    and may increase HDL (good) cholesterol levels in your
                    blood.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[32.56rem] object-cover"
          alt=""
          src="/227@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b className="text-[1.5rem] font-dm-sans">
                <span className="text-white">Spinach</span>
              </b>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <b className="text-[1.5rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Spinach provides many health benefits but very few calories.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  About 3.5 ounces (100 grams) of raw spinach contain 2.7 mg of
                  iron, or 15% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <a
              className="text-[inherit]"
              href={`https://i0.wp.com/images-prod.healthline.com/hlcmsresource/images/topic_centers/2020-1/Spinach-1296x728-body2.jpg?w=1155&h=1528`}
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">&nbsp;</span>
                  </span>
                </span>
              </span>
            </a>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Although this is non-heme iron, which isn’t absorbed very
                  well, spinach is also rich in vitamin C. This is important
                  since vitamin C significantly boosts iron absorption.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Spinach is also rich in antioxidants called carotenoids, which
                  may reduce your risk of cancer, decrease inflammation, and
                  protect your eyes from disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Consuming spinach and other leafy greens with fat helps your
                  body absorb the carotenoids, so make sure to eat a healthy fat
                  like olive oil with your spinach.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  Spinach provides 15% of the DV for iron per serving, along
                  with several vitamins and minerals. It also contains important
                  antioxidants.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[35.19rem] object-cover"
          alt=""
          src="/228@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center text-left text-[1.5rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>{`Liver & Organ Meats`}</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>
                    Organ meats are extremely nutritious. Popular types include
                    liver, kidneys, brain, and heart — all of which are high in
                    iron.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    For example, a 3.5-ounce (100-gram) serving of beef liver
                    contains 6.5 mg of iron, or 36% of the DV.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Organ meats are also high in protein and rich in B vitamins,
                    copper, and selenium.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Liver is especially high in vitamin A, providing an
                    impressive 1,049% of the DV per 3.5-ounce serving.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    What’s more, organ meats are among the best sources of
                    choline, an important nutrient for brain and liver health
                    that many people don’t get enough of.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Organ meats are good sources of iron, and liver contains 36%
                    of the DV per serving. Organ meats are also rich in many
                    other nutrients, such as selenium, vitamin A, and choline.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[44.81rem] object-cover"
          alt=""
          src="/229@2x.png"
        />
        <div className="self-stretch flex flex-row items-center justify-center text-left text-[1.5rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <ul className="m-0 pl-[2.5rem]">
              <li className="mb-[0rem]">
                <b>
                  <span>Legumes</span>
                </b>
              </li>
            </ul>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  <span>Legumes are loaded with nutrients.</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Some of the most common types of legumes are beans, lentils,
                    chickpeas, peas, and soybeans.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    They’re a great source of iron, especially for vegetarians.
                    One cup (198 grams) of cooked lentils contains 6.6 mg, which
                    is 37% of the DV.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Beans like black beans, navy beans, and kidney beans can all
                    help easily bump up your iron intake.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    In fact, a half-cup (86-gram) serving of cooked black beans
                    provides around 1.8 milligrams of iron, or 10% of the DV.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Legumes are also a good source of folate, magnesium, and
                    potassium.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    What’s more, studies have shown that beans and other legumes
                    can reduce inflammation in people with diabetes. Legumes can
                    also decrease heart disease risk for people with metabolic
                    syndrome.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    Additionally, legumes may help you lose weight. They’re very
                    high in soluble fiber, which can increase feelings of
                    fullness, reduce calorie intake, and promote healthy gut
                    bacteria, which influences weight, inflammation and risk of
                    chronic disease.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    To maximize iron absorption, consume legumes with foods high
                    in vitamin C, such as tomatoes, greens, or citrus fruits.
                  </span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>&nbsp;</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>SUMMARY</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>&nbsp;</span>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>
                    One cup (198 grams) of cooked lentils provides 37% of the DV
                    for iron. Legumes are also high in folate, magnesium,
                    potassium, and fiber and may even aid weight loss.
                  </span>
                </span>
              </span>
            </p>
          </div>
        </div>
        <img
          className="relative w-[96.75rem] h-[38.75rem] object-cover"
          alt=""
          src="/230@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.5rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Red Meat</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>Red meat is satisfying and nutritious.</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 3.5-ounce (100-gram) serving of ground beef contains 2.7 mg
                  of iron, which is 15% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Meat is also rich in protein, zinc, selenium, and several B
                  vitamins.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Researchers have suggested that iron deficiency may be less
                  likely in people who eat meat, poultry, and fish on a regular
                  basis.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In fact, red meat is probably the single most easily
                  accessible source of heme iron, potentially making it an
                  important food for people who are prone to anemia.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Research shows females consuming less than 2 ounces of red
                  meat daily were more likely to have inadequate intakes below
                  for zinc, iron, vitamin B12 and potassium and vitamin D
                  intakes than females consuming between 2 and 3 ounces daily.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One serving of ground beef contains 15% of the DV for iron and
                  is one of the most easily accessible sources of heme iron.
                  It’s also rich in B vitamins, zinc, selenium, and high quality
                  protein.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[26.5rem] object-cover"
          alt=""
          src="/231@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.5rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Pumpkin Seeds</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>Pumpkin seeds are a tasty, portable snack.</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 1-ounce (28-gram) serving of pumpkin seeds contains 2.5 mg
                  of iron, which is 14% of the DV).
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In addition, pumpkin seeds are a good source of vitamin K,
                  zinc, and manganese. They’re also among the best sources of
                  magnesium, which is a common dietary deficiency.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 1-ounce (28-gram) serving contains 40% of the DV for
                  magnesium, which helps reduce your risk of insulin resistance,
                  diabetes, and depression.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Pumpkin seeds provide 14% of the DV for iron per 1-ounce
                  serving. They’re also a good source of several other
                  nutrients, particularly magnesium.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[26.06rem] object-cover"
          alt=""
          src="/232@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.5rem]">
          <ul className="m-0 pl-[2.5rem]">
            <li className="mb-[0rem]">
              <b>
                <span>Quinoa</span>
              </b>
            </li>
          </ul>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Quinoa is a popular grain known as a pseudocereal. One cup
                  (185 grams) of cooked quinoa provides 2.8 mg of iron, which is
                  16% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Furthermore, quinoa contains no gluten, making it a good
                  choice for people with celiac disease or other forms of gluten
                  intolerance.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Quinoa is also higher in protein than many other grains, as
                  well as rich in folate, magnesium, copper, manganese, and many
                  other nutrients.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In addition, quinoa has more antioxidant activity than many
                  other grains. Antioxidants help protect your cells from damage
                  from free radicals, which are formed during metabolism and in
                  response to stress.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Quinoa provides 16% of the DV for iron per serving. It also
                  contains no gluten and is high in protein, folate, minerals,
                  and antioxidants.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[27.25rem] object-cover"
          alt=""
          src="/233@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">8. Turkey</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Turkey meat is a healthy and delicious food. It’s also a good
                  source of iron, especially dark turkey meat.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 3.5-ounce (100-gram) portion of dark turkey meat has 1.4 mg
                  of iron, which is 8% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In comparison, the same amount of white turkey meat contains
                  only 0.7 mg (
                </span>
              </span>
            </span>
            <a
              className="text-[inherit]"
              href="https://fdc.nal.usda.gov/fdc-app.html#/food-details/171491/nutrients"
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">
                      38Trusted Source
                    </span>
                  </span>
                </span>
              </span>
            </a>
            <span>
              <span>
                <span>).</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Dark turkey meat also packs an impressive 28 grams of protein
                  per serving and several B vitamins and minerals, including 32%
                  of the DV for zinc and 57% of the DV for selenium.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Consuming high protein foods like turkey may aid weight loss,
                  as protein makes you feel full and increases your metabolic
                  rate after a meal.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  High protein intake can also help prevent the muscle loss that
                  occurs during weight loss and the aging process.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  Turkey provides 13% of the DV for iron and is a good source of
                  several vitamins and minerals. Its high protein content
                  promotes fullness, increases metabolism, and prevents muscle
                  loss
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[31.06rem] object-cover"
          alt=""
          src="/242@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>9. Broccoli</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Broccoli is incredibly nutritious. A 1-cup (156-gram) serving
                  of cooked broccoli contains 1 mg of iron, which is 6% of the
                  DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  What’s more, a serving of broccoli also packs 112% of the DV
                  for vitamin C, which helps your body absorb the iron better.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The same serving size is also high in folate and provides 5
                  grams of fiber, as well as some vitamin K. Broccoli is a
                  member of the cruciferous vegetable family, which also
                  includes cauliflower, Brussels sprouts, kale, and cabbage.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Cruciferous vegetables contain indole, sulforaphane, and
                  glucosinolates, which are plant compounds believed to protect
                  against cancer.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  One serving of broccoli provides 6% of the DV for iron and is
                  very high in vitamins C, K, and folate. It may also help
                  reduce cancer risk.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[37.25rem] object-cover"
          alt=""
          src="/243@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>10. Tofu</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Tofu is a soy-based food that’s popular among vegetarians and
                  in some Asian countries.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A half-cup (126-gram) serving provides 3.4 mg of iron, which
                  is 19% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Tofu is also a good source of thiamine and several minerals,
                  including calcium, magnesium, and selenium. In addition, it
                  provides 22 grams of protein per serving.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Tofu contains unique compounds called isoflavones, which have
                  been linked to improved insulin sensitivity, a decreased risk
                  of heart disease, and relief from menopausal symptoms.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Tofu provides 19% of the DV for iron per serving and is rich
                  in protein and minerals. Its isoflavones may improve heart
                  health and relieve menopausal symptoms.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[34.44rem] object-cover"
          alt=""
          src="/236@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>11. Dark Chocolate</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Dark chocolate is incredibly delicious and nutritious.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A 1-ounce (28-gram) serving contains 3.4 mg of iron, which is
                  19% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  This small serving also packs 56% and 15% of the DVs for
                  copper and magnesium, respectively.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In addition, it contains prebiotic fiber, which nourishes the
                  friendly bacteria in your gut.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Cocoa powder and dark chocolate have significant antioxidant
                  activity similar to that of fruit extracts from berries and
                  cherries.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Studies have also shown that chocolate has beneficial effects
                  on cholesterol and may reduce your risk of heart attacks and
                  strokes.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, not all chocolate is created equal. It’s believed
                  that compounds called flavanols are responsible for
                  chocolate’s benefits, and the flavanol content of dark
                  chocolate is much higher than that of milk chocolate.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Therefore, it’s best to consume chocolate with a minimum of
                  70% cocoa to get the maximum benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  A small serving of dark chocolate contains 19% of the DV for
                  iron along with several minerals and prebiotic fiber that
                  promotes gut health.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[33.56rem] object-cover"
          alt=""
          src="/237@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">12. Fish</span>
            </b>
          </p>
          <p className="m-0">
            <span>
              <b className="text-[1.88rem] font-dm-sans">&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Fish is a highly nutritious ingredient, and certain varieties
                  like tuna are especially high in iron.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In fact, a 3-ounce (85-gram) serving of canned tuna contains
                  about 1.4 mg of iron, which is approximately 8% of the DV.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <a
              className="text-[inherit]"
              href={`https://i0.wp.com/images-prod.healthline.com/hlcmsresource/images/topic_centers/2020-1/fish-1296x728-body12.jpg?w=1155&h=1528`}
              target="_blank"
            >
              <span>
                <span>
                  <span>
                    <span className="[text-decoration:underline]">&nbsp;</span>
                  </span>
                </span>
              </span>
            </a>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Fish is also brimming with omega-3 fatty acids, which are a
                  type of heart-healthy fat associated with a number of health
                  benefits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In particular, omega-3 fatty acids have been shown to promote
                  brain health, enhance immune function, and support healthy
                  growth and development.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Consult the EPA chart to see the healthiest choices of fish
                  and minimize your exposure to mercury.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Fish also contains several other essential nutrients,
                  including niacin, selenium, and vitamin B12.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Besides tuna, haddock, mackerel, and sardines are a few other
                  examples of iron-rich fish that you can also include in your
                  diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span className="font-dm-sans">
                  A serving of canned tuna can provide about 8% of the DV for
                  iron. Fish is also a good source of several other important
                  nutrients, including omega-3 fatty acids, vitamins, and
                  minerals.
                </span>
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[52.63rem] object-cover"
          alt=""
          src="/238@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Bottom Line</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Iron is an important mineral that must be consumed regularly as
                your body cannot produce it on its own.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Yet, it should be noted that some people need to limit their
                intake of red meat and other foods high in heme iron.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, most people are easily able to regulate the amount they
                absorb from food.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Remember that if you don’t eat meat or fish, you can boost
                absorption by including a source of vitamin C when eating plant
                sources of iron.
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson41"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson40;
